import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'

export const mergeSx = (
  ...sx: Array<SxProps<Theme> | boolean | undefined | null>
): SxProps<Theme> => {
  return sx.reduce((acc, sx) => {
    if (!sx) {
      return acc
    }

    return [...acc, ...(Array.isArray(sx) ? sx : [sx])]
  }, [] as any)
}
